import { SovosBox, SovosFileUpload } from "mosaic-react";
import { SovosLinearProgress } from "mosaic-react";
import { forwardRef, useState } from "react";

const UploadFileForm = ({ filesList, showLinearProgress }, ref) => {
    const [fileList, setFileList] = useState([]);

    const handleFilesSelected = (filesToUpload) => {
        filesList.current.push(...filesToUpload);
        setFileList((prev) => [
            ...prev,
            ...filesToUpload.map((file) => ({ name: file.name, bytes: file.size })),
        ]);
    };

    const handleFileDelete = (deletedFile) => {
        filesList.current = filesList.current.filter(
            (file) => file.name !== deletedFile.name
        );
        setFileList((prev) => prev.filter((f) => f.name !== deletedFile.name));
    };

    return (
        <SovosBox>
            <SovosBox>
                {showLinearProgress?.current && <SovosLinearProgress />}
                <SovosFileUpload
                    sx={{ width: "100%" }}
                    buttonLabel={"Browse"}
                    fileList={fileList}
                    acceptedTypes={[
                        "csv",
                        "text/xml",
                        "application/zip",
                        "application/gzip",
                        "application/x-gzip",
                        "text/plain",
                        "application/xml",
                        "application/x-zip-compressed",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "text/txt"
                    ]}
                    onFilesSelected={handleFilesSelected}
                    onFileDelete={handleFileDelete}
                    onFileClick={() => { }}
                />
            </SovosBox>
        </SovosBox>
    );
};

const UploadFileFormFormRef = forwardRef(UploadFileForm);

export default UploadFileFormFormRef;
